const DEFAULT_VIEWPORT = { width: 1200, height: 800 };

export function getLayoutViewportSize() {
    if (typeof window === "undefined") return DEFAULT_VIEWPORT;
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

export function getVisibleViewportSize() {
    if (typeof window === "undefined") return DEFAULT_VIEWPORT;
    const visualViewport = window.visualViewport;
    return {
        width: visualViewport?.width ?? window.innerWidth,
        height: visualViewport?.height ?? window.innerHeight
    };
}

export function clampFixedPosition(position, size, margin = 16) {
    const { width: viewportW, height: viewportH } = getLayoutViewportSize();
    const minTop = margin;
    const minLeft = margin;
    const maxLeft = Math.max(minLeft, viewportW - size.width - margin);
    const maxTop = Math.max(minTop, viewportH - size.height - margin);
    const top = Number(position?.top);
    const left = Number(position?.left);
    return {
        top: Math.max(minTop, Math.min(Number.isFinite(top) ? Math.round(top) : minTop, maxTop)),
        left: Math.max(minLeft, Math.min(Number.isFinite(left) ? Math.round(left) : minLeft, maxLeft))
    };
}

export function clampVisibleSize(size, { minWidth, minHeight, maxWidth, maxHeight }, margin = 16) {
    const { width: viewportW, height: viewportH } = getVisibleViewportSize();
    const maxW = Math.min(maxWidth, viewportW - margin * 2);
    const maxH = Math.min(maxHeight, viewportH - margin * 2);
    const width = Number(size?.width);
    const height = Number(size?.height);
    return {
        width: Math.max(minWidth, Math.min(Number.isFinite(width) ? Math.round(width) : minWidth, maxW)),
        height: Math.max(minHeight, Math.min(Number.isFinite(height) ? Math.round(height) : minHeight, maxH))
    };
}
